import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Table, Button, Dropdown, Label, Input, Message } from 'semantic-ui-react';
import i18next from 'i18next';
import { confirm, editBudgetLoad, loadBudget, calcLoadBudget, fetchCompanyPaymentOptions } from '../../../actions';
import { formatPrice } from '../../../helpers/format';
import { dateToPeriodString } from '../../../helpers/company';

class LoadBudget extends Component {
    state = { selectedPaymentId: 0 };

    componentWillMount() {
        if (this.props.company.id && !this.props.paymentOptions.length) {
            this.props.fetchCompanyPaymentOptions(this.props.company.id);
        }
    }

    handleSubmit = (event) => {
        const { company } = this.props;
        const { possibleDates, dateSelection, calced, bank_code, branch_code, bank_account } = this.props.budgetLoad;
        const date = possibleDates[dateSelection];

        if (!calced) {
            this.props.calcLoadBudget(company.id, date);
        } else {
            this.props.confirm({
                title: i18next.t('loadBudget'),
                message: i18next.t('loadBudgetMessage', { amount: formatPrice(calced.amount, company.currency_code) }),
                onConfirm: () => this.props.loadBudget(company.id, date, { bank_code, branch_code, bank_account })
            });
        }

        event.preventDefault();
    }

    renderPaymentSection(budgetLoad) {
        if (budgetLoad.calced) {
            if (budgetLoad.calced.cards.length === 0) {
                return (
                    <Label basic color='red' style={{ marginBottom: 10 }}>
                        {i18next.t('noCardsToLoad')}
                    </Label>
                );
            }

            if (budgetLoad.calced.amount) {
                return [
                    <Form.Field key="1">
                        <label>{i18next.t('pickPaymentAccount')}</label>
                        <Dropdown
                            fluid
                            selection
                            options={[{ value: 0, text: i18next.t('newPaymentAccount') }].concat(this.props.paymentOptions.map(data => ({ value: data.id, text: data.bank_account })))}
                            value={this.state.selectedPaymentId}
                            onChange={(e, { value }) => {
                                this.setState({ selectedPaymentId: value });
                                if (value) {
                                    const paymentOption = this.props.paymentOptions.find(p => p.id === value);
                                    if (paymentOption) {
                                        this.props.editBudgetLoad('bank_code', paymentOption.bank_code);
                                        this.props.editBudgetLoad('branch_code', paymentOption.branch_code);
                                        this.props.editBudgetLoad('bank_account', paymentOption.bank_account);
                                    }
                                } else {
                                    this.props.editBudgetLoad('bank_code', null);
                                    this.props.editBudgetLoad('branch_code', null);
                                    this.props.editBudgetLoad('bank_account', null);
                                }
                            }}
                        />
                    </Form.Field>,
                    <Form.Group widths='equal' key="2">
                        <Form.Field>
                            <label>{i18next.t('bank')}</label>
                            <Input
                                fluid
                                type='text'
                                placeholder={i18next.t('bank')}
                                required
                                value={budgetLoad.bank_code || ''}
                                onChange={({ target }) => this.props.editBudgetLoad('bank_code', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>{i18next.t('bankBranch')}</label>
                            <Input
                                fluid
                                type='text'
                                placeholder={i18next.t('bankBranch')}
                                required
                                value={budgetLoad.branch_code || ''}
                                onChange={({ target }) => this.props.editBudgetLoad('branch_code', target.value)}
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>{i18next.t('bankAccount')}</label>
                            <Input
                                fluid
                                type='text'
                                placeholder={i18next.t('bankAccount')}
                                required
                                value={budgetLoad.bank_account || ''}
                                onChange={({ target }) => this.props.editBudgetLoad('bank_account', target.value)}
                            />
                        </Form.Field>
                    </Form.Group>,
                    <Message key="3" content={i18next.t('allowBankTransfer')} />
                ];
            }
        }
    }

    render() {
        const { budgetLoad, company } = this.props;
        if (!budgetLoad) {
            return null;
        }

        const options = budgetLoad.possibleDates.map((date, index) => ({ value: index, text: dateToPeriodString(date) }));
        const month = budgetLoad.possibleDates[budgetLoad.dateSelection].getMonth() + 1;

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('pickBudgetPeriod')}</label>
                    <Dropdown
                        fluid
                        selection
                        options={options}
                        value={budgetLoad.dateSelection}
                        onChange={(e, { value }) => this.props.editBudgetLoad('dateSelection', value)}
                    />
                </Form.Field>

                {!budgetLoad.calced ? null :
                    <Table basic collapsing unstackable style={{ width: '100%' }}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>
                                    {i18next.t('budgetMonthlyLoadCalced', { month: i18next.t(`month${month}`) })}
                                </Table.Cell>
                                <Table.Cell>
                                    {formatPrice(budgetLoad.calced.monthlyTotalLoad, company.currency_code)}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>
                                    {i18next.t(budgetLoad.calced.monthlyLoaded ? 'budgetMonthlyLoadedAlready' : 'budgetLoadDelta')}
                                </Table.Cell>
                                <Table.Cell>
                                    {formatPrice(budgetLoad.calced.monthlyLoaded || budgetLoad.calced.delta, company.currency_code)}
                                </Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell>
                                    {i18next.t('budgetLoadPayment')}
                                </Table.Cell>
                                <Table.Cell>
                                    {formatPrice(budgetLoad.calced.amount, company.currency_code)}
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                }

                {this.renderPaymentSection(budgetLoad)}

                <Button
                    primary
                    type='submit'
                    floated="right"
                    disabled={budgetLoad.calced && budgetLoad.calced.cards.length === 0}
                >
                    {i18next.t(budgetLoad.calced ? 'loadBudget' : 'calcBudgetLoad')}
                </Button>
            </Form>
        );
    }
}

LoadBudget.propTypes = {
    company: PropTypes.object,
    fetchCompanyPaymentOptions: PropTypes.func,
    paymentOptions: PropTypes.array,
    budgetLoad: PropTypes.object,
    loadBudget: PropTypes.func,
    calcLoadBudget: PropTypes.func,
    editBudgetLoad: PropTypes.func,
    confirm: PropTypes.func,
    
};

const mapStateToProps = (state) => {
    const { budgetLoad, paymentOptions } = state.budgetsApp;

    return { budgetLoad, paymentOptions };
};

export default connect(mapStateToProps, { confirm, editBudgetLoad, loadBudget, calcLoadBudget, fetchCompanyPaymentOptions })(LoadBudget);
